export default "__VITE_ASSET__CMBsRemG__"